import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  Box,
  Tooltip,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useAdd from "../../../../api/useAdd";
import { useAuth } from "../../../../context";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Procedures = () => {
  const auth = useAuth();
  const token = auth?.user?.token;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    cost: "",
  });

  const [errors, setErrors] = useState({});
  const { handleAdd, resetForm, loading } = useAdd("dental-procedure", token);

  useEffect(() => {
    if (resetForm) {
      setFormData({
        name: "",
        description: "",
        cost: "",
      });
    }
  }, [resetForm]);

  const validate = () => {
    let newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = t("dental.nameRequired");
    }
    if (formData.cost === "") {
      newErrors.cost = t("dental.costRequired");
    } else if (Number(formData.cost) <= 0) {
      newErrors.cost = t("dental.costBePositiveNumber");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      {
        handleAdd(formData);
        setErrors({});
      }
    }
  };

  return (
    <Grid container mt={2} mb={10}>
      <Grid item xs={12} lg={12}>
        <Paper
          component="form"
          onSubmit={handleSubmit}
          sx={{
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            padding: "30px 40px",
            borderRadius: "8px",
            mb: 5,
          }}
        >
          {/* Go Back Icon and Title */}
          <Box display="flex" alignItems="center" mb={4}>
            <Tooltip title={t("dental.goBack")} arrow>
              <IconButton
                onClick={() => navigate(-1)}
                aria-label={t("dental.goBack")}
                sx={{ mr: 2 }}
              >
                <ArrowBackIcon size="large" />
              </IconButton>
            </Tooltip>
          </Box>

          <Typography variant="h5" gutterBottom>
            {t("dental.addNewProcedure")}
          </Typography>

          <TextField
            label={t("dental.name")}
            fullWidth
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            sx={{ mb: 3 }}
            error={!!errors.name}
            helperText={errors.name}
          />

          <TextField
            label={t("dental.description")}
            fullWidth
            multiline
            rows={4}
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            sx={{ mb: 3 }}
          />

          <TextField
            label={t("dental.cost")}
            fullWidth
            type="number"
            value={formData.cost}
            onChange={(e) => setFormData({ ...formData, cost: e.target.value })}
            sx={{ mb: 3 }}
            error={!!errors.cost}
            helperText={errors.cost}
          />

          <Button
            variant="contained"
            disabled={loading}
            type="submit"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              padding: "10px 20px",
              backgroundColor: "#071952",
              ":hover": {
                backgroundColor: "#071952",
              },
            }}
          >
            {loading ? t("dental.saving") : t("dental.addProcedure")}
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Procedures;
